import * as React from "react";
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import InfoIcon from "assets/svg/InfoIcon"
import information from "assets/images/notification-blue.png";

const MaterialToolTip = (props) =>{

    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
        ))(({ theme }) => ({
        zIndex: theme.zIndex.tooltip + 1,
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: '#FFFFFF',
            color: '#000000',
            border: '.5px solid #999999',
            fontSize: '.75rem',
            fontWeight: '400',
            cursor: 'pointer'
        }
    }));
    
 return(
  <>
    <StyledTooltip title={props?.title }  placement="top">
        {!props?.infoIcon? 
            <img
            className={`${props?.class} i-icon-btn i-icon`}       
            src={information}
            />
        :
            <button className="i-icon-btn">
             <InfoIcon className="i-icon" />
            </button>
        }
    </StyledTooltip>
  </>
);
}

export default MaterialToolTip;
